import React, { Fragment, useState } from "react";
// import styled from "styled-components";

import { CheckboxLabel, CheckboxInput } from "components/CheckboxLabel";

import { formPropTypes } from "./prop-types";
import { FormPartial, Title, StyledP2, Input } from "../styles";

export const DesiredComponentsForm = ({ base }) => {
  const [hasSolar, setHasSolar] = useState(false);
  const [hasGenerator, setHasGenerator] = useState(false);
  return (
    <Fragment>
      <Title>Desired Components</Title>
      <StyledP2>
        Select the features you’d like to include in your system
      </StyledP2>
      {/* <Checkboxes> */}
      <FormPartial
        css={`
          grid-row-gap: unset;
          padding: 0px 0px 16px 0px;
          > input {
            margin: 6px 0px 10px 0px;
          }
          > label {
            padding: 4px 0px;
          }
        `}
      >
        <CheckboxLabel>
          <CheckboxInput name={base("EnergyStorageSystem")} type="checkbox" />
          <span>{"Energy Storage System (Battery)"}</span>
        </CheckboxLabel>
        <CheckboxLabel>
          <CheckboxInput name={base("FLM")} type="checkbox" />
          <span>{"Flexible Load Management (Smart Load Panel)"}</span>
        </CheckboxLabel>
        <CheckboxLabel>
          <CheckboxInput name={base("SolarPanels")} type="checkbox" />
          <span>{"Solar Panels"}</span>
        </CheckboxLabel>
        <CheckboxLabel>
          <CheckboxInput name={base("Generator")} type="checkbox" />
          <span>{"Generator"}</span>
        </CheckboxLabel>
        <CheckboxLabel>
          <CheckboxInput
            type="checkbox"
            name={base("AlreadyHaveSolar")}
            onChange={isChecked => setHasSolar(isChecked)}
            data-enzyme="solar-checkbox"
          />
          <span>{"I already have solar"}</span>
        </CheckboxLabel>
        <Input
          label="Solar size"
          name={base("SolarSize")}
          placeholder="Solar size (kW)"
          disabled={!hasSolar}
          data-enzyme="solar-input"
          type="text"
        />
        <CheckboxLabel>
          <CheckboxInput
            type="checkbox"
            name={base("AlreadyHaveGenerator")}
            onChange={isChecked => setHasGenerator(isChecked)}
            data-enzyme="generator-checkbox"
          />
          <span>{"I already have a generator"}</span>
        </CheckboxLabel>
        <Input
          label="Generator size"
          placeholder="Generator Size (kW)"
          name={base("GeneratorSize")}
          disabled={!hasGenerator}
          data-enzyme="generator-input"
          type="text"
        />
        <label htmlFor={base("GeneratorSize")} className="hideAccessible">
          {"Generator size"}
        </label>
        {/* </Checkboxes> */}
      </FormPartial>
    </Fragment>
  );
};

DesiredComponentsForm.propTypes = formPropTypes;
